import type { EvidenceTask } from '@knowyet/sdk/evidence';
/** Replay original task records chronologically. Each answer keeps its own artifact
 * and citations; reading history never submits a new workflow. */
export function replayTasks(tasks: EvidenceTask[]): EvidenceTask[] {
  const build = tasks.find((t) => t.operation === 'build');
  return tasks
    .filter((t, i) => i === 0 || t === build || t.operation === 'analyze' || t.operation === 'resume')
    .reverse();
}
